import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { useEffect } from 'react';
import { useNotification } from 'hooks/ui/useNotification';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/investor-reporting';

async function createDeploymentUpdate(requestBody) {
  const { data: response } = await api.post(
    `deployment-update/create/${requestBody?.shareAllocationUploadId}`,
    requestBody,
  );
  return response;
}

function useDeploymentUpdateCreateAPI() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createDeploymentUpdate,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['deployment-updates'] }),
  });
}

export function useDeploymentUpdateView(id: string) {
  return useQuery({
    queryKey: ['deployment-update', id],
    queryFn: async () => {
      const { data } = await api.get<
        ApiResponse<Api.GetDeploymentUpdateResponse>
      >(`deployment-update/${id}`);
      return data.data.deploymentUpdate;
    },
    enabled: !!id,
  });
}

export function useDeploymentUpdate() {
  const notification = useNotification();
  const create = useDeploymentUpdateCreateAPI();

  useEffect(() => {
    //@ts-expect-error
    const errorMessage = create.error?.response?.data?.responseMsg;

    if (errorMessage) {
      notification.error(errorMessage);
    }
    //@ts-expect-error
  }, [create.error?.response?.data?.responseMsg, notification]);

  useEffect(() => {
    const successMessage = create.data?.responseMsg;

    if (successMessage) {
      notification.success(successMessage);
    }
  }, [create.data?.responseMsg, notification]);

  return {
    create,
  };
}
